import { z } from "zod";

import { zSubjectSchema } from "./subject";

import { UserEntity } from "~/entities/user/@x/inquiry";
import { zEmptyString } from "~/shared/zod";

const zSchema = z.object({
  id: z.string().uuid(),
  fullName: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 7),
  message: z
    .string()
    .trim()
    .nonempty()
    .max(2 ** 10),
  subject: zSubjectSchema,
  createdAt: z.date(),
  isResolved: z.boolean(),
  adminComment: z.string().max(2 ** 10),
  contacts: z.union([
    z.object({
      email: UserEntity.zSchema.shape.email,
      phone: z.union([zEmptyString, UserEntity.zSchema.shape.phone]),
    }),
    z.object({
      email: z.union([zEmptyString, UserEntity.zSchema.shape.email]),
      phone: UserEntity.zSchema.shape.phone,
    }),
  ]),
});
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
